import React from "react";
import MemberModal from "./components/MemberModal";

const MathModelling = ({ fontSize }) => {
  return (
    <div>
      <div className="mathDiv membersDiv ">
        <div className="cardContainer grid-container">
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Adrian Foell "
            program="Chemical Engineering "
            term="4A "
            bird="Night Owl "
            lab="Incubator "
            travel="Paris "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/adrian-foell-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/adrian-foell-silly.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Amy Wohlgemuth "
            program="Chemical Engineering "
            term="3A "
            bird="Early Bird "
            lab="Quality control equipment "
            travel="Germany "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/amy-wohlgemuth-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/amy-wohlgemuth-profile.jpg "
            }
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Andre Villanueva "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/andre-villanueva-profile.png"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/andre-villanueva-profile.png "
            }
            program="Biomedical Engineering "
            term="2A "
            bird="Night Owl "
            lab="Goggles "
            travel="Iceland "
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Chelsea Huang "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/chelsea-huang-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/chelsea-huang-silly.jpeg "
            }
            program="Biomedical Engineering "
            term="3B "
            bird="Night Owl "
            lab="Erlenmeyer flask "
            travel="Iceland "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Chimdindu Ohaegbu "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/chimdindu-ohaegbu-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/chimdindu-ohaegbu-silly.jpg "
            }
            program="Chemical Engineering "
            term="3A "
            bird="Early Bird "
            lab="Microscope "
            travel="Barcelona, Spain "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Faizaan Adtani "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/faizaan-adtani-profile.jpeg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/faizaan-adtani-profile.jpeg "
            }
            program="Biomedical Science with Bioinformatics Option "
            term="4A "
            bird="Perpetually Tired "
            lab="Tweezers "
            travel="Singapore "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Gerald Lee "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/gerald-lee-profile.jpeg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/gerald-lee-profile.jpeg "
            }
            program="Computer Science "
            term="3B "
            bird="Night Owl "
            lab="Autoclave "
            travel="Japan "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Ke Xin (Katie) Chen "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/katie-chen-profile.png"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/katie-chen-silly.png"
            }
            program="Biomedical Engineering "
            term="4A "
            bird="Early Bird "
            lab="Erlenmeyer flask "
            travel="Nakayama Kaigan, Kagoshima, Japan "
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Kellie Chong "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/kells-chong-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/kells-chong-profile.jpg "
            }
            program="Nanotechnology Engineering "
            term="4A "
            bird="Perpetually Tired "
            lab="Miltichannel Pipette "
            travel=" "
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Rachel Zhang "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rachel-zhang-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rachel-zhang-profile.jpg "
            }
            program="Nanotechnology Engineering "
            term="3B "
            bird="Early Bird "
            lab=" "
            travel="Italy "
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Rene Lam "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rene-lam-profile.png"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/rene-lam-silly.png "
            }
            program="Nanotechnology Engineering "
            term="3B "
            bird="Early Bird "
            lab="Magnetic stir bar "
            travel="Greece "
          />

          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Rohan Mistry "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rohan-mistry-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/rohan-mistry-profile.jpg "
            }
            program="Biomedical Engineering "
            term="2A "
            bird="Night Owl "
            lab="Eyewash station "
            travel="Maldives "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Sydney Sherwood "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/sydney-sherwood-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/sydney-sherwood-silly.jpg "
            }
            program="Biomedical Engineering "
            term="2A "
            bird="Night Owl "
            lab="Centrifuge "
            travel="Switzerland "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Taylor Roth "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/taylor-roth-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/taylor-roth-silly.jpg "
            }
            program="Chemical Engineering "
            term="3A "
            bird="Early Bird "
            lab="Paper towel "
            travel="Iceland "
          />
          <MemberModal
            class="grid-item"
            font={{ fontSize: `${20 + fontSize}px` }}
            subteam="Math & Modelling"
            name="Wendy Lu "
            pic={
              "https://static.igem.wiki/teams/4393/wiki/members/profile-photos/wendy-lu-profile.jpg"
            }
            altPic={
              "https://static.igem.wiki/teams/4393/wiki/members/silly-photos/wendy-lu-silly.jpg "
            }
            program="Computer Science "
            term="3A "
            bird="Night Owl "
            lab="Beaker "
            travel="Yosemite National Park "
          />
        </div>
      </div>
    </div>
  );
};

export default MathModelling;
